export const smbOnboarding = {
  title: "Create Your Business Page",
  navigation: {
    back: "Back",
    next: "Next",
    finish: "Finish"
  },
  toast: {
    name_required: "Name Required",
    name_required_desc: "Please enter your business name before continuing.",
    thank_you: "Thank You!",
    thank_you_desc: "Your onboarding information has been submitted.",
    saved: "Profile Saved",
    saved_desc: "Your business profile has been successfully created.",
    error: "Error",
    error_desc: "There was an error saving your profile. Please try again."
  },
  steps: {
    business_info: {
      title: "Business Information",
      description: "Enter your business basic information.",
      business_name: "Business Name",
      business_name_placeholder: "e.g. Beautiful Hair Salon",
      business_category: "Business Type",
      business_category_placeholder: "Select your business type",
      address: "Address",
      address_placeholder: "1234 Example Street",
      phone: "Phone Number",
      phone_placeholder: "+1 234 567 8900",
      email: "Email Address",
      email_placeholder: "info@mybusiness.com",
      website: "Website (optional)",
      website_placeholder: "https://www.mybusiness.com",
      logo: "Logo",
      upload_logo: "Upload Logo",
      logo_help: "Click to upload (Min. 500x500 pixels recommended)",
      bio: "Business Description",
      bio_placeholder: "Tell us about your business, what services you offer, what makes you special...",
      categories: {
        salon: "Hair Salon",
        barbershop: "Barbershop",
        beauty_salon: "Beauty Salon",
        nail_salon: "Nail Salon",
        spa: "Spa / Wellness",
        massage: "Massage",
        yoga_studio: "Yoga Studio",
        fitness_center: "Fitness Center",
        pilates_studio: "Pilates Studio",
        dance_studio: "Dance Studio",
        personal_training: "Personal Training",
        nutritionist: "Nutritionist",
        physiotherapy: "Physiotherapy",
        dental: "Dental Office",
        veterinary: "Veterinary Clinic",
        cafe: "Cafe",
        restaurant: "Restaurant",
        bakery: "Bakery",
        photography: "Photography Studio",
        tutoring: "Tutoring",
        music_school: "Music School",
        art_studio: "Art Studio",
        consulting: "Consulting",
        accounting: "Accounting",
        legal: "Legal Service",
        real_estate: "Real Estate",
        cleaning: "Cleaning",
        repair: "Repair / Service",
        pet_grooming: "Pet Grooming",
        other: "Other"
      },
      tip_title: "Tip",
      tip_description: "Basic information helps your customers find you and contact you. Make sure all data is accurate and up-to-date."
    },
    services: {
      title: "Services",
      description: "Enter the services you offer to your customers.",
      add_service: "Add Service",
      service_name: "Service Name",
      service_name_placeholder: "e.g. Women's Haircut",
      service_description: "Description",
      service_description_placeholder: "Short description of the service",
      service_price: "Price ($)",
      service_price_placeholder: "50",
      service_duration: "Duration (minutes)",
      service_duration_placeholder: "60",
      no_services: "No services added yet",
      services_added: "services added",
      remove_service: "Delete",
      tip_title: "Tip",
      tip_description: "Provide clear prices and durations. This helps your customers decide and book appointments."
    },
    opening_hours: {
      title: "Opening Hours",
      description: "Enter your business opening hours.",
      day_closed: "Closed",
      day_open: "Open",
      from: "From",
      to: "To",
      add_break: "Add Break",
      remove_break: "Remove Break",
      break_from: "Break Start",
      break_to: "Break End",
      days: {
        monday: "Monday",
        tuesday: "Tuesday",
        wednesday: "Wednesday",
        thursday: "Thursday",
        friday: "Friday",
        saturday: "Saturday",
        sunday: "Sunday"
      },
      tip_title: "Tip",
      tip_description: "Accurate opening hours help your customers plan. If you have lunch breaks or other closed periods, add them too."
    },
    team: {
      title: "Team (optional)",
      description: "Add your team members who work at your business.",
      add_member: "Add Team Member",
      member_name: "Name",
      member_name_placeholder: "e.g. Jane Doe",
      member_role: "Position",
      member_role_placeholder: "e.g. Hairstylist",
      member_bio: "Bio (optional)",
      member_bio_placeholder: "Short introduction about the team member",
      member_photo: "Photo",
      upload_photo: "Upload Photo",
      no_members: "No team members added yet",
      members_added: "team members added",
      remove_member: "Delete",
      tip_title: "Tip",
      tip_description: "Introducing your team makes your business more personal and builds trust with customers. This step is optional, you can add team members later."
    },
    design: {
      title: "Design Preferences",
      description: "Choose your preferred visual style for your page.",
      tip_title: "Pro Tip",
      tip_description: "Good design builds trust and helps you stand out from competitors. Choose a style that reflects your business personality."
    }
  }
};